module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/de-card-drag.8eb16913a6659e67ff64.gif";